import React,{useEffect,useState} from 'react';
import {Box,Typography,Button,Alert} from '@mui/material';
import {TokenValidator} from '../../../../../utils';
export default function CurrentTracking({orderId}){
 const [value,setValue]=useState(null),[error,setError]=useState(''),[revision,setRevision]=useState(0),[copyStatus,setCopyStatus]=useState('');
 useEffect(()=>{
  let current=true;const abort=new AbortController();setValue(null);setError('');
  const timeout=setTimeout(()=>abort.abort(),10000);
  (async()=>{try{
   const token=await TokenValidator.GetInternalUser();
   const response=await fetch(`/api/orders/${encodeURIComponent(orderId)}/current-tracking`,{headers:{Authorization:token||''},signal:abort.signal,cache:'no-store'});
   if(!response.ok)throw Error('No se pudo consultar la etiqueta vigente.');
   const result=await response.json();if(current)setValue(result.trackingIds);
  }catch(e){if(current)setError('No se pudo consultar la etiqueta vigente. Intenta actualizar.');}
  finally{clearTimeout(timeout);}})();
  return()=>{current=false;clearTimeout(timeout);abort.abort();};
 },[orderId,revision]);
 useEffect(()=>{const refresh=()=>{if(!document.hidden)setRevision(n=>n+1);};const timer=setInterval(refresh,30000);window.addEventListener('focus',refresh);return()=>{clearInterval(timer);window.removeEventListener('focus',refresh);};},[]);

 const handleCopy=async()=>{
  if(!value?.length)return;
  const trackingText=value.join('; ');
  try{
   await navigator.clipboard.writeText(trackingText);
   setCopyStatus('copied');
   setTimeout(()=>setCopyStatus(''),2000);
  }catch(e){
   setCopyStatus('error');
  }
 };

 return <Box sx={{my:2}}><Typography variant='h6'>TRACKING ID</Typography>
  {error?<Alert severity='warning'>{error}</Alert>:<Typography sx={{overflowWrap:'anywhere'}}>{value===null?'Consultando…':value.length?value.join('; '):'Sin etiqueta de envío'}</Typography>}
  <Box sx={{display:'flex',flexWrap:'wrap',gap:1,my:1}}>
   <Button variant='outlined' onClick={handleCopy} disabled={!value?.length}>{copyStatus==='copied'?'COPIADO':'COPIAR TRACKING ID'}</Button>
   <Button onClick={()=>setRevision(n=>n+1)}>Actualizar tracking</Button>
  </Box>
  {copyStatus==='error'?<Alert severity='warning' sx={{mb:1}}>No se pudo copiar automáticamente. Selecciona el Tracking ID y cópialo manualmente.</Alert>:null}
  <Typography variant='caption'>Etiqueta vigente · sólo lectura. Se actualiza al regresar a esta pantalla o cada 30 segundos.</Typography>
 </Box>;
}
